import { alert } from "notie";

function getFavourites() {
    try {
        return JSON.parse(localStorage.getItem("favourites")) ?? [];
    } catch (err) {
        return [];
    }
}

function addFavourite(favourite) {
    const favourites = getFavourites();
    favourites.push(favourite);
    alertText("#notie-added", "info", `<svg class="icon-favourite favourite-plus"><use xlink:href="#icon-heart" /></svg>`);
    localStorage.setItem("favourites", JSON.stringify(favourites));
    countFavourites();
}

function removeFavourite(favourite) {
    const favourites = getFavourites().filter((value) => value !== favourite);
    alertText("#notie-removed", "error", `<svg class="icon-favourite favourite-plus"><use xlink:href="#icon-heart-minus" /></svg>`);
    localStorage.setItem("favourites", JSON.stringify(favourites));
    countFavourites();
}

function isAddedFavourite(favourite) {
    return getFavourites().find((value) => value === favourite);
}

function alertText(selector, type = "info", icon = "") {
    const lang = document.querySelector(selector);
    if (lang) {
        alert({ type: type, text: `<span>${lang.innerHTML}</span>${icon}`, position: 'top', time: 2 });
    }
}

function addFavouriteListener(e) {
    e.preventDefault();
    const buttons = [...document.querySelectorAll(`.add-to-favourites[data-favourite="${this.dataset.favourite}"`)];

    if (isAddedFavourite(this.dataset.favourite)) {
        buttons.map(el => el.classList.remove("is-added"));
        removeFavourite(this.dataset.favourite);
        // delete node from favourites list
        [
            ...document.querySelectorAll(
                `#favourites-list .list-offer-item[data-favourite='${this.dataset.favourite}']`
            )
        ].map((el) => el.remove());
    } else {
        buttons.map(el => el.classList.add("is-added"));
        addFavourite(this.dataset.favourite);
    }
}

function addFavouriteNode(data) {
    const newItem = document.querySelector(".clone-favourite").cloneNode(true);
    newItem.classList.remove("clone-favourite");
    newItem.querySelector(".list-offer-img").src = data.image;
    newItem.querySelector(".list-offer-city").innerHTML = data.location;
    newItem.querySelector(".list-offer-street").innerHTML = data.street;

    if (data.number_of_bedrooms != 0) {
        newItem.querySelector(".list-offer-icon-desc-bedroom").innerHTML = data.number_of_bedrooms;
    } else {
        newItem.querySelector(".list-offer-icon-desc-bedroom").parentElement.remove();
    }

    if (data.number_of_bathrooms != 0) {
        newItem.querySelector(".list-offer-icon-desc-bathroom").innerHTML = data.number_of_bathrooms;
    } else {
        newItem.querySelector(".list-offer-icon-desc-bathroom").parentElement.remove();
    }

    if (data.total_area != 0) {
        newItem.querySelector(".list-offer-icon-desc-area").innerHTML = data.total_area + " m<sup>2</sup>";
    } else {
        newItem.querySelector(".list-offer-icon-desc-area").parentElement.remove();
    }

    newItem.querySelector(".list-offer-item-link").href = data.url;
    newItem.querySelector(".add-to-favourites").dataset.favourite = data.slug;
    newItem.dataset.favourite = data.slug;

    const currency = localStorage.getItem("gk_currency") ?? "PLN";
    if (currency === "PLN") {
        newItem.querySelector(".price-here").innerHTML = data.price_pln;
        newItem.querySelector(".currency-here").innerHTML = "PLN";
    } else {
        newItem.querySelector(".price-here").innerHTML = data.price_eur;
        newItem.querySelector(".currency-here").innerHTML = "EUR";
    }

    newItem.querySelector(".add-to-favourites").addEventListener("click", addFavouriteListener);
    document.querySelector("#favourites-list").appendChild(newItem);
}

function addFavouritesToForm() {
    [...document.querySelectorAll('.favorite_input')].map((el) => el.remove());

    const slugs = [...document.querySelectorAll('.add-to-favourites')].map((el) => el.dataset.favourite);
    const form = document.querySelector('#sendYourFavorites form');

    if (slugs.length && form) {
        slugs.forEach((slug) => {
            if (!slug) {
                return;
            }
            const input = document.createElement('input');
            input.name = 'favorite_id[]';
            input.value = slug;
            input.className = 'favorite_input';
            input.type = 'hidden';
            form.appendChild(input);
        });
    }
}

function countFavourites() {
    const counterEl = document.querySelector(".icon-like-counter");
    if (!counterEl) {
        return console.error("There is no counting element.");
    }

    const counter = getFavourites().length;
    let outerText = "";

    if (counter > 0) {
        outerText = (counter < 10 ? '0' : '') + counter
    }

    counterEl.innerHTML = outerText;

    const heartEl = document.querySelector(".icon-like-svg");
    if (!heartEl) {
        return console.error("There is no heart element.");
    }

    if (outerText) {
        heartEl.classList.add("icon-like-svg--filed");
    } else {
        heartEl.classList.remove("icon-like-svg--filed");
    }
}

const flist = document.querySelector("#favourites-list");

if (flist) {
    const favourites = getFavourites();
    const urls = [];
    for (let fav of favourites) {
        urls.push(`?slug=${fav}&type=json`);
    }
    Promise.all(urls.map((url) => fetch(url).then((resp) => resp.json()))).then((json) => {
        json.map((data) => {
            if (data['slug'] && data['is_valid']) {
                addFavouriteNode(data);
                const emptyMessage = document.querySelector('.favourites-empty-message');
                if (emptyMessage) {
                    emptyMessage.remove();
                }
                // enable buttons
                const buttons = document.querySelector('.favourites-buttons');
                if (buttons) {
                    buttons.classList.add('show');
                }
            } else if (data['slug']) {
                // remove is favourite is not valid
                removeFavourite(data['slug']);
            }
        });
    });
}

[...document.querySelectorAll(".add-to-favourites")].map((element) => {
    element.addEventListener("click", addFavouriteListener);

    if (isAddedFavourite(element.dataset.favourite)) {
        element.classList.add("is-added");
    }
});

[...document.querySelectorAll(".list-offer-item")].map((element) => {
    const favourite = element.dataset.favourite;
    if (isAddedFavourite(favourite)) {
        element.classList.add("is-favourite");
    }
});

const sendMeButton = document.querySelector('#sendYourFavoritesButtons');
if (sendMeButton) {
    sendMeButton.addEventListener('click', () => addFavouritesToForm());
}

countFavourites();
